import { Component, OnInit } from '@angular/core';
import { MetaService } from '@ngx-meta/core';
import { URL } from '../../environments/environment';
import { RACKEO_SITE } from '../shared/rackeo-site';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  readonly URL = URL;

  constructor(private readonly meta: MetaService) {}

  ngOnInit(): void {
    this.meta.setTitle('Página no encontrada | Rackeo');
    this.meta.setTag('description', 'La página que buscas no existe o fue movida. Vuelve al inicio de Rackeo.');
    this.meta.setTag('og:type', 'website');
    this.meta.setTag('og:image:type', 'image/png');
    this.meta.setTag('og:image', RACKEO_SITE.ogImageUrl);
    this.meta.setTag('og:image:width', '1200');
    this.meta.setTag('og:image:height', '1200');
    this.meta.setTag('og:image:alt', 'Página no encontrada | Rackeo');
    this.meta.setTag('og:locale', RACKEO_SITE.ogLocale);
  }
}
